import { superAdminUrl } from "~config";

export const isSuperAdminDomain = () =>
  typeof window !== "undefined"
    ? window?.location?.hostname
        ?.split(".")[0]
        .startsWith(superAdminUrl.split(".")[0].replace("https://", ""))
    : undefined;
